const httpBasicEndpointConfig = {
  name: 'HTTP Basic Endpoint',
  endpoint: '/internal_admin/admin_kit/http_basic_endpoints',
  modelKey: 'http_basic_endpoint',
  titleField: 'url',

  columns: [
    { name: 'url', title: 'URL', type: 'link' },
    { name: 'account_name', title: 'Account' },
    { name: 'decisiv_id', title: 'Decisiv ID' },
    { name: 'enabled', title: 'Enabled', type: 'boolean' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[url_cont]', label: 'URL' },
    {
      name: 'q[enabled_eq]',
      label: 'Status',
      options: (props) => props.enabledOptions ?? [],
    },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'url', label: 'URL' },
    { name: 'username', label: 'Username' },
    { name: 'account_name', label: 'Account Name' },
    { name: 'decisiv_id', label: 'Decisiv ID' },
    { name: 'srm_account_id', label: 'SRM Account ID' },
    { name: 'enabled', label: 'Enabled', type: 'boolean' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  panels: [
    {
      type: 'subscription',
      title: 'Events',
      eventsEndpoint: '/internal_admin/admin_kit/webhook_events',
      subscribeEndpoint: (record) =>
        `/internal_admin/admin_kit/http_basic_endpoints/${record.id}/subscribe`,
      unsubscribeEndpoint: (record) =>
        `/internal_admin/admin_kit/http_basic_endpoints/${record.id}/unsubscribe`,
    },
  ],

  form: {
    fields: [
      {
        name: 'account_id',
        label: 'Account',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/http_basic_endpoints/dealer_search',
        displayField: 'account_label',
        helpMessage: 'Search by dealer name or Decisiv ID (min 2 characters)',
      },
      { name: 'url', label: 'URL', type: 'text', required: true },
      { name: 'username', label: 'Username', type: 'text' },
      {
        name: 'password',
        label: 'Password',
        type: 'password',
        helpMessage: 'Leave blank to keep the current password',
      },
      {
        name: 'enabled',
        label: 'Enabled',
        type: 'checkbox',
        defaultValue: false,
      },
    ],
  },
};

export default httpBasicEndpointConfig;
